import React, { useState } from "react";
import styled, { css } from "styled-components";

import { DesignSystemSurface, PageHeader } from "../../../design-system";
import EventsTab from "./EventsTab";
import RoundtablesTab from "../roundtables/RoundtablesTab";

const Page = styled.div`
  min-height: calc(100vh - 104px);
  padding: var(--space-6) var(--space-6) var(--space-16);
`;

const PageInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const TabBar = styled.div`
  display: inline-flex;
  gap: 2px;
  padding: 4px;
  background: var(--color-surface-subtle);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-6);
`;

const TabButton = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  border: none;
  background: transparent;
  font-family: var(--font-sans);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition:
    background var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard);

  &:hover {
    color: var(--color-text);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }

  ${(p) =>
    p.$active &&
    css`
      background: var(--color-surface);
      color: var(--color-text);
      font-weight: var(--font-weight-semibold);
      box-shadow: var(--shadow-xs);
    `}
`;

const TABS: { id: number; label: string; title: string; subtitle: string }[] = [
  {
    id: 0,
    label: "Events",
    title: "Events",
    subtitle: "Live sessions and milestones for your community.",
  },
  {
    id: 1,
    label: "Roundtables",
    title: "Roundtables",
    subtitle:
      "AI-led community roundtables. The agenda is generated on create and can be refreshed in the app.",
  },
];

const EventsScreen = () => {
  const [currentTabIndex, setTabIndex] = useState(0);
  const activeTab = TABS[currentTabIndex] || TABS[0];

  return (
    <DesignSystemSurface>
      <Page>
        <PageInner>
          <PageHeader title={activeTab.title} subtitle={activeTab.subtitle} />
          <TabBar role="tablist">
            {TABS.map((tab) => (
              <TabButton
                key={tab.id}
                type="button"
                role="tab"
                $active={currentTabIndex === tab.id}
                aria-selected={currentTabIndex === tab.id}
                onClick={() => setTabIndex(tab.id)}
              >
                {tab.label}
              </TabButton>
            ))}
          </TabBar>
          {currentTabIndex === 0 && <EventsTab />}
          {currentTabIndex === 1 && <RoundtablesTab />}
        </PageInner>
      </Page>
    </DesignSystemSurface>
  );
};

export default EventsScreen;
